// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uanY","location":"Header_location__2J6zh"};